// extracted by mini-css-extract-plugin
export default {"icon-spin":"Spinner_icon-spin__iNCS6"};